// extracted by mini-css-extract-plugin
export default {"title":"CustomModal_title__saRu5","close":"CustomModal_close__Vx8kJ","content":"CustomModal_content__MvJPa"};